<template>
  <div>
    <v-data-table
        no-data-text="Заявки отсутствуют"
        :style="{color: $mainColor}"
        :headers="tech_exp_headers"
        :items="showAllTech ? allTechExpProposals : techExpProposals"
        :loading-text="$t('User.loading_orders')"
        :items-per-page="5"
        :footer-props="{
            itemsPerPageOptions: [5, 15,-1],
            itemsPerPageText: 'кол-во на стр.:',
        }"
    >
      <template v-slot:top>
        <v-container>
          <v-row>
            <v-col class="pt-0 pb-0">
                <v-btn
                    v-if="showAllTech"
                    text
                    small
                    target='_blank'
                    @click="showAllTech = false"
                    color="#16336e">
                    <v-icon>mdi-chevron-up</v-icon>скрыть оцененные<v-icon>mdi-chevron-up</v-icon>
                </v-btn>
                <v-btn
                    v-else
                    text
                    small
                    target='_blank'
                    @click="showAllTech = true"
                    color="#16336e">
                    <v-icon>mdi-chevron-down</v-icon>показать оцененные<v-icon>mdi-chevron-down</v-icon>
                </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:body="{ items, isSelected, select}">
        <tbody>
            <tr v-if="items.length == 0">
                <td colspan="3">
                    <b>Заявки отсутствуют</b>
                </td>
            </tr>
            <tr v-else v-for="item in items" :key="item.id" :class="row_classes(item)" @click="open_proposal_card(item.id)" style="cursor: pointer;">
                <td>
                    <span>
                        <b style="color: #9f00ff;">{{ item.id }}</b><i style="font-style: italic; color: #9f00ff; font-size: 12px;"> от {{ g.toDate(item.date_income) }} </i> {{ item.name }}
                        <br>
                        <i style="font-style: italic;">{{ item.keywords }}</i>
                    </span>
                </td>
                <td>
                    <span>
                        <b>{{ item.author }}</b>
                        <br>
                        <i style="font-style: italic;">{{ item.organisation }}</i>
                    </span>

                </td>
                <td>
                    <span>
                        <b>{{ item.bs_resolution > 0 ? (item.bs_resolution == 1 ? 'Эксперимент невозможен' : 'Возможен эксперимент' ) : 'Ожидает вашей оценки' }}</b>
                        <br>
                        <i style="font-style: italic;">{{ item.bs_text }}</i>
                    </span>

                </td>
            </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>

import { mapActions, mapMutations, mapGetters } from 'vuex'

export default {
    props: {
    },
    components: {
    },

    name: 'TechPossibleTable',

    data: () => ({
      call_id: null,
      techExpProposals: [],
      allTechExpProposals: [],
      showAllTech: false,

      tech_exp_headers: [
        { text: 'Заявка', sortable: true, value: 'id', width: '45%'},
        { text: 'Заявитель', sortable: true, value: 'author', width: '25%'},
        { text: 'Решение', sortable: false, value: 'status', width: '30%'},
      ],

    }),

    computed: {
      ...mapGetters([
        'GETTERS_CURRENT_STATION',
        'GETTERS_NEED_RELOAD_CLOSE_PROPOSAL',
      ])
    },

    methods:{
      ...mapActions([
        'PROPOSAL_VARIABLE_LIST',
      ]),
      ...mapMutations([
        'SHOW_PROPOSAL_CARD',
      ]),

      open_proposal_card(id) {
        this.call_id = new Date()
        this.SHOW_PROPOSAL_CARD({
          'proposal_id' : id,
          'call_id': this.call_id
        })
      },

      async loadListProposals(is_init=false) {
        
          var args = {
            type: 'tech_possible_proposals',
            filters: {
                station_id : this.GETTERS_CURRENT_STATION
            },
          }

          await this.PROPOSAL_VARIABLE_LIST(args)
          .then(proposals => {
            this.allTechExpProposals = proposals

            this.techExpProposals = []

            this.allTechExpProposals.forEach((item, i) => {
                if(item.has_bs_comment)
                    item.color = '#93e093'
                else{
                    item.color = '#ffb800'
                    this.techExpProposals.push(item)
                }
            })

            if(is_init){
                this.$emit('closeTab', this.techExpProposals.length == 0);
            }

          })
      },

      row_classes(item) {
          if(item.bs_resolution == 2)
            return "green_bg";
          else if(item.bs_resolution == 1)
            return "red_bg";
          else
            return "orange_bg";
      },
    },

    async beforeMount() {
        this.loadListProposals(true)
    },

    watch: {
      GETTERS_NEED_RELOAD_CLOSE_PROPOSAL(val){
          if(val && val == this.call_id){
            this.loadListProposals()
          }
      },

      GETTERS_CURRENT_STATION(val){
        if(val){
            this.loadListProposals(true)
        }
      },
    }
};

</script>

